import React from "react"


const Footer = () => {
	var date = new Date();
	var options = { year: 'numeric', month: 'long' };
	var year = date.getFullYear();
	var formattedDate = date.toLocaleDateString('en-US', options);
  return (
	<footer className="report-footer">
	  <p className="default">
		Source:{" "}
		<a href="https://marketproof.com" className="link-text">
		  Marketproof
		</a>{" "}
		| For informational purposes only, data from entities deemed reliable,
		but may contain errors, omissions, or changes without notice.
	  </p>
	  <div className="elliman-disclaimer" style={{display:"none"}}>
	  		<div className="elliman-logo" />
			<div className="top">“Data Powered by MarketProof” {formattedDate}</div>
		  <div>575 MADISON AVENUE, NY, NY 10022. 212.891.7000 © {year} DOUGLAS ELLIMAN REAL ESTATE. ALL MATERIAL PRESENTED HEREIN IS INTENDED FOR INFORMATION PURPOSES ONLY. WHILE, THIS INFORMATION IS BELIEVED TO BE CORRECT, IT IS REPRESENTED SUBJECT TO ERRORS, OMISSIONS, CHANGES OR WITHDRAWAL WITHOUT NOTICE. ALL PROPERTY INFORMATION, INCLUDING, BUT NOT LIMITED TO SQUARE FOOTAGE, ROOM COUNT, NUMBER OF BEDROOMS AND THE SCHOOL DISTRICT IN PROPERTY LISTINGS SHOULD BE VERIFIED BY YOUR OWN ATTORNEY, ARCHITECT OR ZONING EXPERT. IF YOUR PROPERTY IS CURRENTLY LISTED WITH ANOTHER REAL ESTATE BROKER, PLEASE DISREGARD THIS OFFER. IT IS NOT OUR INTENTION TO SOLICIT THE OFFERINGS OF OTHER REAL ESTATE BROKERS. WE COOPERATE WITH THEM FULLY. EQUAL HOUSING OPPORTUNITY. <img src="https://marketproof-hosting.s3.us-east-1.amazonaws.com/equal-housing.png" className="equal-housing" /></div>
	  </div>
	</footer>
  );
};


export default Footer;